module.exports = __webpack_public_path__ + "static/fonts/Montserrat300italic.3eb3e920.ttf";